<template>
    <div>
        <img src="/assets/banners/see_you_soon_2026/nos_vemos_pronto.svg" alt="Nos vemos pronto." class="banner" />
    </div>
</template>

<style>
  body {
    background: white !important;
    overflow: hidden;
  }

  #app { 
    margin: 0 !important;
  }

  .banner {
    width: 100%;
  }
</style>